<template>
    <div role="rowgroup">
        <input-row label="기업명" pointer>
            <input-item v-model="applicant.companyName" disabled @input="sync" />
        </input-row>
        <input-row label="대표자명" pointer>
            <input-item v-model="applicant.ceoName" disabled @input="sync" />
        </input-row>
        <input-row label="사업자등록번호" pointer>
            <input-item v-model="applicant.businessNumber" disabled @input="sync" />
        </input-row>
        <input-row label="기업설립일" pointer>
            <div class="form-birth">
                <input-birth mode="년" v-model="applicant.establishedY" disabled @input="sync" />
                <input-birth mode="월" v-model="applicant.establishedM" disabled @input="sync" />
                <input-birth mode="일" v-model="applicant.establishedD" :year="applicant.establishedY" :month="applicant.establishedM" disabled @input="sync" />
            </div>
        </input-row>
        <input-row label="연락처" pointer>
            <div class="form-tel">
                <input class="input" v-model="applicant.phone1" type="tel" name="phone1" maxlength="4" disabled @input="sync" />
                <span class="text"></span>
                <input class="input" v-model="applicant.phone2" type="tel" name="phone2" maxlength="4" disabled @input="sync" />
                <span class="text"></span>
                <input class="input" v-model="applicant.phone3" type="tel" name="phone3" maxlength="4" disabled @input="sync" />
            </div>
        </input-row>
        <input-row label="이메일" pointer>
            <input-email v-model="applicant" disabled @input="sync" />
        </input-row>
        <input-row label="소재지" pointer>
            <input-address v-model="applicant" disabled @input="sync" />
        </input-row>
        <input-row label="홈페이지 주소">
            <input-item v-model="applicant.website" disabled @input="sync" />
        </input-row>
        <input-row label="담당자명/직책">
            <div class="row row--small">
                <div class="col-12 col-md-6">
                    <input-item v-model="applicant.workerName" disabled @input="sync" />
                </div>
                <div class="col-12 col-md-6">
                    <input-item v-model="applicant.workerTitle" disabled @input="sync" />
                </div>
            </div>
        </input-row>
        <input-row label="주요생산제품">
            <input-item v-model="applicant.mainProduct" disabled @input="sync" />
        </input-row>
        <input-row label="첨부파일" pointer>
            <v-row align="center">
                <!-- <v-col cols="auto">
                    <v-file-btn v-model="newFiles" class="button button--primary" color="primary" multiple elevation="0">파일첨부</v-file-btn>
                </v-col> -->
                <v-col>
                    <v-chip-group v-if="newFiles.length" multiple column>
                        <v-chip v-for="file in newFiles" :key="file.fileName" :value="file" download :href="file.url">{{ file.fileName }}</v-chip>
                    </v-chip-group>
                    <span v-else>첨부된 파일이 없습니다.</span>
                </v-col>
            </v-row>
        </input-row>
    </div>
</template>

<script>
import { SERVICE_PROGRAM_CATEGORIES } from "@/assets/variables";

import VFileBtn from "@/components/plugins/vuetify/v-file-btn.vue";
import InputRow from "@/components/client/dumb/input-row.vue";
import InputItem from "@/components/client/dumb/input-item.vue";
import InputBirth from "@/components/client/dumb/input-birth.vue";
import InputEmail from "@/components/client/dumb/input-email.vue";
import InputAddress from "@/components/client/dumb/input-address.vue";

export default {
    components: {
        VFileBtn,
        InputRow,
        InputItem,
        InputBirth,
        InputEmail,
        InputAddress,
    },
    props: ["value", "program", "files"],
    computed: {
        establishedAt() {
            const { establishedY, establishedM, establishedD } = this.applicant;
            return `${establishedY}-${String(establishedM).padStart(2, "0")}-${String(establishedD).padStart(2, "0")}`;
        },
        phone() {
            const { phone1, phone2, phone3 } = this.applicant;

            return `${phone1}-${phone2}-${phone3}`;
        },
        email() {
            const { email1, email2 } = this.applicant;

            return `${email1}@${email2}`;
        },
        computedApplication() {
            const { establishedAt, phone, email } = this;
            return { ...this.applicant, establishedAt, email, phone };
        },
        isTotalSupport() {
            return this.program.category == SERVICE_PROGRAM_CATEGORIES.TOTAL.value;
        },
    },
    data() {
        return {
            applicant: {},
            newFiles: [],
        };
    },
    methods: {
        init() {
            const { establishedAt, phone, email } = this.value;

            const [establishedY, establishedM, establishedD] = establishedAt.toDate().split("-");
            const [phone1, phone2, phone3] = phone?.split("-");
            const [email1, email2] = email?.split("@");

            this.applicant = {
                ...this.value,
                establishedY,
                establishedM,
                establishedD,
                phone1,
                phone2,
                phone3,
                email1,
                email2,
            };

            this.newFiles = this.files;
        },
        sync() {
            this.$emit("input", this.computedApplication);
        },
    },
    watch: {
        value() {
            if (this.value) this.init();
        },
        files() {
            if (this.files) this.init();
        },
        newFiles() {
            this.$emit("files", this.newFiles);
        },
    },
    mounted() {
        if (this.value) this.init();
    },
};
</script>

<style></style>
